module.exports = __webpack_public_path__ + "static/media/biothings-explorer.6513700f.svg";